import { z } from 'zod';
import { OnboardingFormFields } from '@Types/index.ts';
import { firstNameScheme } from '@Components/inputs/FirstNameInput.tsx';
import { lastNameScheme } from '@Components/inputs/LastNameInput.tsx';
import { passwordScheme } from '@Components/inputs/PasswordInput';

export const personalDetailsScheme = z.object({
  ...firstNameScheme.shape,
  ...lastNameScheme.shape,
});
export const welcomeScheme = z.object({
  ...passwordScheme.shape,
  [OnboardingFormFields.EMAIL]: z.string().email('Invalid email'),
});
export const passwordLessWelcomeScheme = z.object({
  ...welcomeScheme.shape,
  ...personalDetailsScheme.shape,
});

export const getWelcomeFormScheme = (shouldShowExtendedForm: boolean) => {
  return shouldShowExtendedForm ? passwordLessWelcomeScheme : welcomeScheme;
};
